export function CommentIcon() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="29" height="30" viewBox="0 0 29 30" fill="none">
  <g clipPath="url(#clip0_2943_9837)">
    <path d="M14.5 1.25922C6.492 1.25922 0 7.07972 0 14.2592C0 16.9052 0.884 19.3647 2.398 21.4182C2.199 23.7907 1.627 27.1322 0 28.7592C0 28.7592 4.9715 28.0617 8.3385 26.0282C8.342 26.0297 8.346 26.0312 8.3495 26.0327C9.7315 25.1322 11.1155 24.2047 11.402 23.9697C11.552 23.7592 11.8415 23.6957 12.067 23.8312C12.215 23.9202 12.3085 24.0827 12.3115 24.2552C12.3165 24.5662 12.309 24.6472 9.519 26.4657C11.073 26.9757 12.749 27.2592 14.5 27.2592C22.508 27.2592 29 21.4387 29 14.2592C29 7.07972 22.508 1.25922 14.5 1.25922Z" fill="#5B5B5B"/>
    <path d="M7.5 15.7589C8.32843 15.7589 9 15.0874 9 14.2589C9 13.4305 8.32843 12.7589 7.5 12.7589C6.67157 12.7589 6 13.4305 6 14.2589C6 15.0874 6.67157 15.7589 7.5 15.7589Z" fill="white"/>
    <path d="M14.5 15.7589C15.3284 15.7589 16 15.0874 16 14.2589C16 13.4305 15.3284 12.7589 14.5 12.7589C13.6716 12.7589 13 13.4305 13 14.2589C13 15.0874 13.6716 15.7589 14.5 15.7589Z" fill="white"/>
    <path d="M21.5 15.7589C22.3284 15.7589 23 15.0874 23 14.2589C23 13.4305 22.3284 12.7589 21.5 12.7589C20.6716 12.7589 20 13.4305 20 14.2589C20 15.0874 20.6716 15.7589 21.5 15.7589Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_2943_9837">
      <rect width="29" height="29" fill="white" transform="translate(0 0.509079)"/>
    </clipPath>
  </defs>
</svg>
  )
}
